import { render } from "./PaidSBP.vue?vue&type=template&id=da7f41d4"
import script from "./PaidSBP.vue?vue&type=script&lang=js"
export * from "./PaidSBP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__